import { Box, Button, DialogTitle, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Colors, ColorsV2 } from 'app/constants/color';

const StyledConfirm = styled(Button)({
  background: Colors.primary,
  '&:hover': {
    backgroundColor: '#c0801a',
  },
});

const StyledButton = styled(Button)({
  background: '#EFF2F8',
  color: '#4A5F75',
  '&:hover': {
    backgroundColor: '#dde4f0',
  },
});

const CustomDialog = styled(Box)({
  width: '600px',
  height: '300px',
  // borderRadius: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  background: 'black',
});

const CustomStack = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

const CustomDialogTitle1 = styled(DialogTitle)({
  color: ColorsV2.white,
  fontSize: '24px',
});
const CustomDialogTitle2 = styled(DialogTitle)({
  color: ColorsV2.white,
  fontSize: '24px',
});

export {
  StyledButton,
  StyledConfirm,
  CustomDialog,
  CustomStack,
  CustomDialogTitle1,
  CustomDialogTitle2,
};
